import { AtomGetters, injectSelf, useAtomInstance } from '@zedux/react';
import { topicsAtom } from './atoms/topicsAtom';
import { userInfoAtom } from './atoms/socket';
import { IContext, ITopicCategories, IUserInfo, TopicTypes, ParticipantTypes, UserRoles, ITabKey } from './types';
import { activeTopicAtom, temporaryTopicAtom } from './atoms/atoms';


export const getSortedTopicsByTab = ({ get }: AtomGetters, context: IContext, currentTab: ITabKey | null, sort : boolean = true) => {
    const topics = get(topicsAtom, [context]);
    const temporaryTopic = get(temporaryTopicAtom, [context]);
    const userInfo = get(userInfoAtom)

    if (!userInfo || !Array.isArray(topics)) return [];

    const role = Number(userInfo.role);

    const sortedTopics = sort ? [...topics].sort((a, b) => {
        const timeA = a.last_message_created_at || a.created_date || 0;
        const timeB = b.last_message_created_at || b.created_date || 0;
        return timeB - timeA;
    }) : [...topics];

    if (temporaryTopic) {
        // First check if the temporary topic already exists in the topics list
        const existingIndex = sortedTopics.findIndex(t => t.other_user_id === temporaryTopic.temporary_target_user_id);
        // console.log('temporary', temporaryTopic, existingIndex)
        if (existingIndex === -1) {
            sortedTopics.unshift(temporaryTopic);
        }
    }

    if (!currentTab) return [];

    return sortedTopics.filter(topic => {
        // Support
        if (currentTab === 'support') {
            return topic.topic_type === TopicTypes.SUPPORT;
        }

        // Groups / Channels
        if (currentTab === 'groups') {
            return topic.topic_type === TopicTypes.CHANNEL || topic.topic_type === TopicTypes.GROUP;
        }

        // Members
        if (currentTab === 'members') {
            return topic.topic_type === TopicTypes.CHAT &&
                topic.participant_type === ParticipantTypes.USER &&
                (topic.other_participant_type == null || topic.other_participant_type === ParticipantTypes.USER);
        }

        // Vendors (Buyer looking at Vendors)
        if (currentTab === 'vendors') {
            return (
                topic.topic_type === TopicTypes.CHAT &&
                (
                    topic.other_participant_type === ParticipantTypes.VENDOR &&
                    (role === UserRoles.BUYER || role === UserRoles.GUEST)
                )
                ||
                (
                    topic.other_participant_type === ParticipantTypes.USER &&
                    (role === UserRoles.BUYER || role === UserRoles.GUEST)
                )
                ||
                (topic.temporary_target_user_id != null)
            )
        }

        // Buyers (Vendor looking at Buyers)
        if (currentTab === 'buyers') {
            return topic.topic_type === TopicTypes.CHAT &&
                topic.participant_type === ParticipantTypes.VENDOR &&
                (role === UserRoles.VENDOR || role === UserRoles.STAFF);
        }

        return false;
    });
};
